module.exports = __webpack_public_path__ + "img/login-logo.c5c96a48.png";